// locationData.js

import citieslist from './cities.json'
import countrieslist from './countriesmin.json'
export const countries = countrieslist

 export const simulatedCities = citieslist;